<ng-container *ngIf="useVintasoft; else jsprint">
    <dk-document-scanner2 (base64Content)="getScannedContent($event)"></dk-document-scanner2>
</ng-container>
<ng-template #jsprint>
    <dk-document-scanner3 (base64Content)="getScannedContent($event)"></dk-document-scanner3>
</ng-template>